import i18n from 'locales/i18n';
import { Role } from 'types';

export const RoleTranslationsMap: { [key in Role]: string } = {
  [Role.SuperAdmin]: i18n.t('role.SuperAdmin'),
  [Role.SuffixAgent]: i18n.t('role.SuffixAgent'),
  [Role.SuffixAdmin]: i18n.t('role.SuffixAdmin'),
  [Role.Accountant]:i18n.t('role.Accountant')
};
